import React from "react";
import GenericIconAndMaskedValue from "components/card-icons/GenericIconAndMaskedValue.js";
import { PAYMENT_TYPES } from "server/api-types/WSPayment.js";
import {
	levels,
	log,
} from "utils/Logger.js";

/**
 * When we have a WSFundingSourceInfo, we have the nickname
 *
 * @param {WSFundingSourceInfoChip} wsFundingSourceInfo
 * @returns {JSX.Element}
 */
const FundingSourceInfoChip = ({
	wsFundingSourceInfo,
	showName,
	className,
	maskedPanClassName,
	iconClassName,
	showPrimary = false,
	...restProps
}) => {
	const getIconType = () => {
		if (wsFundingSourceInfo.directDebit) {
			return PAYMENT_TYPES.directDebit;
		}

		if (wsFundingSourceInfo.creditCard) {
			return PAYMENT_TYPES.creditCard;
		}

		log(null, levels.error, `FundingSourceInfoChip: unknown wsFundingSourceInfo`);
		return "";
	};

	const getMaskedPan = () => {
		const creditCard = wsFundingSourceInfo.creditCard ?? {};
		const {
			maskedPan,
			maskedPAN = null,
		} = creditCard;

		return maskedPan ?? maskedPAN;
	};

	const iconType = getIconType();
	const nickname = wsFundingSourceInfo.nickname;
	const accountType = wsFundingSourceInfo.directDebit?.accountType;
	const creditCardType = wsFundingSourceInfo.creditCard?.creditCardType;
	const maskedBankAccountNumber =  wsFundingSourceInfo.directDebit?.maskedBankAccountNumber;
	const maskedPan = getMaskedPan();
	const primary = wsFundingSourceInfo.setAsPrimary;

	return (
		<GenericIconAndMaskedValue {...{
			showPrimary,
			primary,
			showName,
			iconType,
			nickname,
			accountType,
			creditCardType,
			maskedBankAccountNumber,
			maskedPan,
			className,
			iconClassName,
			maskedPanClassName,
		}} {...restProps} />
	);
};
export default FundingSourceInfoChip;
